// assets/variant-steps.js
(function () {
  function init(productInfo) {
    const root = productInfo.closest('[id^="MainProduct-"]') || productInfo;
    const form = productInfo.querySelector('product-form form');
    const idInput = form?.querySelector('input[name="id"]');
    const addBtn  = form?.querySelector('[type="submit"]');
    const dynBtn  = productInfo.querySelector('.shopify-payment-button');
    if (!form || !idInput) return;

    // Always ignore ?variant= in the URL so Dawn doesn't prefill or snap back
    const params = new URLSearchParams(location.search);
    const urlHasVariant = false; // force "no URL variant"
    if (params.has('variant')) {
      params.delete('variant');
      const qs = params.toString();
      history.replaceState({}, '', `${location.pathname}${qs ? `?${qs}` : ''}`);
    }

    const getSelects = () =>
      Array.from(productInfo.querySelectorAll('variant-selects select'));

    let ignoring = false;   // guard around our programmatic changes
    let chosenUpTo = -1;    // highest index the user has actually chosen

    const chosen = (s) => s && s.value !== '';
    const allChosen = (sels) => sels.every(chosen);

    function setReady(ready) {
      // Apply class to both the section wrapper and <product-info>
      root.classList.toggle('all-chosen', ready);
      productInfo.classList.toggle('all-chosen', ready);

      if (addBtn) {
        addBtn.disabled = !ready;
        addBtn.setAttribute('aria-disabled', String(!ready));
      }
      if (dynBtn) dynBtn.style.display = ready ? '' : 'none';
    }

    function ensurePlaceholders(sels) {
      sels.forEach((sel) => {
        if (!sel.querySelector('option._placeholder')) {
          const label =
            (sel.closest('fieldset')?.querySelector('legend')?.textContent ||
              sel.previousElementSibling?.textContent ||
              'Option').trim();
          const opt = document.createElement('option');
          opt.value = '';
          opt.disabled = true;
          opt.className = '_placeholder';
          opt.textContent = `Select ${label}`;
          sel.insertBefore(opt, sel.firstChild);
        }
      });
    }

    function computeProgress(sels) {
      for (let i = 0; i < sels.length; i++) {
        if (!chosen(sels[i])) return i;
      }
      return sels.length;
    }

    function lock(sels) {
      const progress = computeProgress(sels);
      for (let i = 0; i < sels.length; i++) {
        const s = sels[i];
        if (i <= progress) {
          s.disabled = false;
          s.closest('.select')?.classList.remove('is-disabled');
        } else {
          s.disabled = true;
          s.closest('.select')?.classList.add('is-disabled');
          if (s.value !== '') {
            ignoring = true;
            s.value = '';
            const ph = s.querySelector('option._placeholder');
            if (ph) ph.selected = true;
            ignoring = false;
          }
        }
      }
      // Price/SKU show only when all chosen and a real variant id exists
      setReady(allChosen(sels) && !!idInput.value);
    }

    function clearFrom(sels, fromIndex) {
      ignoring = true;
      for (let j = fromIndex; j < sels.length; j++) {
        const s = sels[j];
        Array.from(s.options).forEach((o) => o.removeAttribute('selected'));
        s.value = '';
        const ph = s.querySelector('option._placeholder');
        if (ph) ph.selected = true;
      }
      // While the user is still choosing, blank the id to keep price/SKU hidden
      idInput.value = '';
      ignoring = false;
    }

    function onChange(e) {
      if (ignoring) return;
      const sels = getSelects();
      const idx = sels.indexOf(e.currentTarget);
      chosenUpTo = idx; // remember which dropdown the user just changed
      clearFrom(sels, idx + 1);               // clear ONLY future steps
      lock(sels);
    }

    // ---------- Initial setup ----------
    const selects0 = getSelects();
    ensurePlaceholders(selects0);

    // Start with placeholders (no prefill)
    if (!urlHasVariant) {
      chosenUpTo = -1;
      clearFrom(selects0, 0);
      setReady(false);
    }

    lock(selects0);
    selects0.forEach((sel) => sel.addEventListener('change', onChange));

    // When Shopify sets the hidden variant id, flip readiness if all options are chosen
    idInput.addEventListener('change', () => {
      if (allChosen(getSelects()) && idInput.value) setReady(true);
    });

    // If Dawn announces a variant while not all options are chosen, keep hidden
    document.addEventListener(
      'variant:change',
      () => {
        const sels = getSelects();
        if (!allChosen(sels)) {
          // Do NOT blank id here; just mark not ready until user finishes
          setReady(false);
          lock(sels);
        } else {
          setReady(!!idInput.value);
        }
      },
      { passive: true }
    );

    // When Dawn replaces <variant-selects>, preserve chosen steps and clear only future ones
    const mo = new MutationObserver((muts) => {
      const replaced = muts.some((m) =>
        Array.from(m.addedNodes).some(
          (n) =>
            n.nodeType === 1 &&
            (n.matches?.('variant-selects') || n.querySelector?.('variant-selects'))
        )
      );
      if (!replaced) return;

      setTimeout(() => {
        const sels = getSelects();
        ensurePlaceholders(sels);

        const notAll = !allChosen(sels);
        const shouldClear = notAll && ((chosenUpTo >= 0) || !urlHasVariant);

        if (shouldClear) {
          // User is still choosing — clear only FUTURE steps, keep price/SKU hidden
          ignoring = true;
          sels.forEach((s, j) => {
            if (j > chosenUpTo) {
              Array.from(s.options).forEach((o) => o.removeAttribute('selected'));
              s.value = '';
              const ph = s.querySelector('option._placeholder');
              if (ph) ph.selected = true;
            }
          });
          idInput.value = ''; // keep hidden while incomplete
          ignoring = false;
          setReady(false);
        } else {
          // All options chosen — DO NOT blank the variant id
          setReady(!!idInput.value);
        }

        // Rebind change handlers and re-lock
        sels.forEach((sel) => {
          sel.removeEventListener('change', onChange);
          sel.addEventListener('change', onChange);
        });

        lock(sels);
      }, 0);
    });

    mo.observe(productInfo, { childList: true, subtree: true });
  }

  document.addEventListener('product-info:loaded', (e) => {
    if (e.target?.tagName?.toLowerCase() === 'product-info') init(e.target);
  });
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-info').forEach(init);
  });
})();

